export { useAuthHeader } from './api/authHeaders';
export { buildUrl } from './api/buildUrl';
export { getMockAuth } from './api/mockServices';
export { GMTtoCET, FormatCET, getMonthLabel, isDateInPast } from './formatting/dateUtils';
export { TextToHtml } from './formatting/textToHtml';
export { exportToJson } from './data/exportJsonToFile'; 
export {calculateLineStyles} from './data/calculateLineStyles';
export {createGradient} from './formatting/chartUtils';
export {formatEmailList} from './formatting/emailUtils';
